import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import '../Style/Business.css';

gsap.registerPlugin(ScrollTrigger);

const Business = () => {
  const sectionRef = useRef(null);
  const textRef = useRef(null);
  const imagesRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Text animation - replays on each scroll
      gsap.fromTo(textRef.current,
        { x: -50, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 75%',
            toggleActions: 'play none none none'
          }
        }
      );

      // Images animation - replays on each scroll
      gsap.fromTo(imagesRef.current,
        { x: 50, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 1,
          delay: 0.2,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 75%',
            toggleActions: 'play none none none'
          }
        }
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <div ref={sectionRef}>
    <div className="business-container">
      <div className="business-text" ref={textRef}>
        <h2>Quick-Turn PCB <br />Manufacturing Company</h2>
        <p>
          Automotive Devices is an electronics manufacturing company that specializes
          in printed circuit board (PCB) assembly located in the heart of Lahore.
        </p>
        <p>
          We specialize in high-quality quick-turn (1–5 days) NPI/prototype builds as well
          as mid-to-large sized production runs.
        </p>
        <p>
          Don’t want to waste time and effort on procuring parts? Automotive Devices provides both full
          turnkey and consignment options on all builds. We currently run 6 full SMT lines
          with JUKI pick-and-place machines capable of assembling BGAs, FPBGAs, QFNs, and
          passive components down to 0201 and 01005.
        </p>
           <h3 style={{
            fontSize: '2rem',
           }}>Our business includes many industries:
</h3>
            <div className="industry-list">
 
  <div className="industry-item">
    <span className="arrow-circle">&#8594;</span>
    <span className="industry-name">Networking</span> &nbsp;&nbsp;&nbsp;&nbsp;
       <span className="arrow-circle">&#8594;</span>
    <span className="industry-name">Communications</span>
  </div>

  <div className="industry-item">
    <span className="arrow-circle">&#8594; </span>
    <span className="industry-name">Semi-conductor</span>
    <span className="arrow-circle">&#8594;</span>
    <span className="industry-name">Memory</span>
  </div>
 
</div>
      </div>

      <div className="business-images" ref={imagesRef}>
<div className="img-grid">
  <img src="/im1.jpeg" alt="Hands-on PCB Work" className="img-pcb-hands" />
  <img src="/im2.jpeg" alt="Glowing World PCB" className="img-pcb-glow" />
  <img src="/im3.jpeg" alt="Hard Drive Data" className="img-pcb-drive" />
</div>

</div>


      </div>
  
    </div>
  );
};

export default Business;
